<template>
    <tr>
        <td class="d-flex flex-row align-center justify-center">
            <v-btn :disabled="ultima" plain x-small @click="orderUp">
                <v-icon>mdi-menu-down</v-icon>
            </v-btn>
            <div>{{ arvore.ordem }}</div>
            <v-btn :disabled="primeira" plain x-small @click="orderDown">
                <v-icon>mdi-menu-up</v-icon>
            </v-btn>
        </td>
        <td>
            <router-link
                :to="{ name: 'DetalheArvore', params: { id: arvore.id } }"
                >{{ arvore.nome }}</router-link
            >
        </td>
        <td>{{ arvore.autor }}</td>
        <td>
            <v-icon v-if="arvore.habilitada">mdi-rocket-launch</v-icon>
            <v-icon v-if="!arvore.habilitada">mdi-pause-circle</v-icon>
        </td>
        <td>{{ formataData(arvore.alterada) }}</td>
    </tr>
</template>

<script>
import utils from "../../../utils/general"; // formataData, limite, etc....

export default {
    name: "arvore-item",
    props: {
        arvore: { required: true },
        primeira: { required: true },
        ultima: { required: true },
    },
    methods: {
        ...utils,
        orderDown() {
            this.$emit("orderDown", this.arvore.id);
        },
        orderUp() {
            this.$emit("orderUp", this.arvore.id);
        },
    },
};
</script>
